import React, { useState } from 'react';
import { Modal, Button, FormField } from '@prosolve/common-components-ui'
import useForm from '../hooks/useForm';
import { isValidAssetName, isReservedAssetName, getParentPath } from './assetNameUtils';

export default ({
  itemType, // 'file' | 'folder'
  currentName = '',
  currentKey = '', // file key or folder path
  onClose,
  onSubmit // (newName) => void — parent routes through the URL-change confirmation
}) => {
  const formData = useForm({
    requiredFields: ['newName'],
    initData: { newName: currentName }
  })

  const [validationError, setValidationError] = useState('')

  const newName = (formData.values.newName || '').trim()
  const isUnchanged = newName === currentName

  const onSave = () => {
    if (!newName || isUnchanged) return;

    if (!isValidAssetName(newName)) {
      setValidationError('Names must start with a letter or number and can only contain letters, numbers, spaces, dots, underscores, parentheses and hyphens.');
      return;
    }
    if (!getParentPath(currentKey) && isReservedAssetName(newName)) {
      setValidationError(`"${newName}" is a reserved name and can't be used at the top level.`);
      return;
    }

    onSubmit(newName)
  }

  const footer = (
    <div style={{
      display: 'flex',
      justifyContent: 'flex-end',
      alignItems: 'center',
      columnGap: '10px',
      padding: '10px'
    }}>
      <Button onClick={onClose}>
        {'Cancel'}
      </Button>
      <Button onClick={onSave} $colored={true} $disabled={!newName || isUnchanged}>
        {'Save'}
      </Button>
    </div>
  )

  return (
    <Modal title={`Rename ${itemType === 'folder' ? 'Folder' : 'File'}`} isAutoHeight={true} closeOnOffClick={false} onClose={onClose} footer={footer}>
      <div style={{ display: 'flex', flexDirection: 'column', rowGap: '10px' }}>
        <FormField
          fieldId='newName'
          type='text'
          label='New name'
          formData={formData}
        />
        {validationError && <div style={{ color: '#ef0c0c', fontSize: '13px' }}>{validationError}</div>}
      </div>
    </Modal>
  )
}
